<template>
  <div class="d-block">
    <div class="gg-btns-list-group">
      <slot
        :isActive="isActive"
        :handleClick="handleClick"
        :getItemValue="getItemValue"
        :getItemText="getItemText"
        :normalizedSelection="normalizedSelection"
      />
    </div>
    <small v-if="errorMessages && errorMessages.length" class="error--text mt-1" role="alert">
      {{ errorMessage }}
    </small>
  </div>
</template>

<script>
export default {
  name: 'GGButtonsListGroup',
  props: {
    value: {
      type: [String, Number, Array],
      default: null
    },
    itemValueKey: {
      type: String,
      default: 'value'
    },
    multi: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: [String, Array],
      default: () => []
    },
  },
  computed: {
    normalizedSelection () {
      if (this.multi) {
        if (Array.isArray(this.value)) return this.value
        if (this.value === null || this.value === undefined) return []
        return [this.value]
      }
      return this.value || ''
    },
    errorMessage () {
      return Array.isArray(this.errorMessages) ? this.errorMessages[0] : this.errorMessages
    }
  },
  methods: {
    getItemValue (item) {
      return typeof item === 'object' ? item[this.itemValueKey] : item
    },
    getItemText (item) {
      if (typeof item === 'object') {
        return item.text || item.label || item[this.itemValueKey] || ''
      }
      return item
    },
    isActive (value) {
      if (this.multi) {
        return this.normalizedSelection.includes(value)
      }
      return this.normalizedSelection === value
    },
    handleClick (value) {
      if (this.multi) {
        const currentSelection = Array.isArray(this.value) ? [...this.value] : []
        const index = currentSelection.indexOf(value)

        if (index === -1) {
          currentSelection.push(value)
        } else {
          currentSelection.splice(index, 1)
        }

        this.$emit('input', currentSelection)
      } else {
        if (this.normalizedSelection !== value) {
          this.$emit('input', value)
        }
      }
    }
  }
}
</script>

<style scoped>
.gg-btns-list-group {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
}
</style>
